import { createBrowserRouter } from 'react-router';
import App from '../App';

export const browserRouter = createBrowserRouter([{ path: '*', element: <App /> }]);
